import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  adminOnly?: boolean;
  requireOnboarding?: boolean;
}

export default function ProtectedRoute({
  children,
  adminOnly = false,
  requireOnboarding = false
}: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-16 w-16 rounded-xl bg-gray-900 dark:bg-gray-100 flex items-center justify-center text-white dark:text-gray-900 font-bold text-2xl shadow-lg">
            B
          </div>
          <h2 className="mt-6 text-xl font-medium text-gray-700 dark:text-gray-300">Loading...</h2>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin access if required
  if (adminOnly && user.email !== 'admin@bizamply.com') {
    return <Navigate to="/dashboard" replace />;
  }

  // Handle onboarding requirements
  if (requireOnboarding && user.firstimeSetup === 0) {
    return <Navigate to="/onboarding" replace />;
  }

  // Render the protected component
  return <>{children}</>;
}
